exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page_title[data-v-563daae8]{text-align:center;font-size:30px;padding:20px 0 20px}.page_desc[data-v-563daae8]{font-size:18px;text-align:center;margin-bottom:40px}.captcha[data-v-563daae8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.imgs[data-v-563daae8]{margin-left:20px}.imgs img[data-v-563daae8]{height:36px}.success[data-v-563daae8]{color:#11a983}", ""]);

// exports
